import { render, staticRenderFns } from "./PageLimitSwitcher.vue?vue&type=template&id=73168171&scoped=true&"
import script from "./PageLimitSwitcher.vue?vue&type=script&lang=js&"
export * from "./PageLimitSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PageLimitSwitcher.vue?vue&type=style&index=0&id=73168171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73168171",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73168171')) {
      api.createRecord('73168171', component.options)
    } else {
      api.reload('73168171', component.options)
    }
    module.hot.accept("./PageLimitSwitcher.vue?vue&type=template&id=73168171&scoped=true&", function () {
      api.rerender('73168171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/PageLimitSwitcher.vue"
export default component.exports